<script setup lang="ts">
/** Icônes de la page d'accueil — même trait fin que la maquette d'origine. */
withDefaults(
  defineProps<{
    name: 'arrow' | 'check' | 'chevron' | 'send' | 'document' | 'menu' | 'shield' | 'spark' | 'wallet' | 'search' | 'x' | 'camera' | 'quote' | 'calendar' | 'pen' | 'bell' | 'card' | 'user' | 'chart';
    size?: number;
  }>(),
  { size: 20 },
);
</script>

<template>
  <svg
    aria-hidden="true"
    fill="none"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.8"
  >
    <template v-if="name === 'arrow'"><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></template>
    <path v-else-if="name === 'check'" d="m5 12 4 4L19 6" />
    <path v-else-if="name === 'chevron'" d="m6 9 6 6 6-6" />
    <template v-else-if="name === 'send'"><path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4Z" /></template>
    <template v-else-if="name === 'document'"><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></template>
    <path v-else-if="name === 'menu'" d="M4 8h16M4 16h16" />
    <template v-else-if="name === 'shield'"><path d="M12 3 5 6v5c0 4.5 2.8 8.2 7 10 4.2-1.8 7-5.5 7-10V6z" /><path d="m9 12 2 2 4-5" /></template>
    <path v-else-if="name === 'spark'" d="M12 2c.4 5.9 3.1 8.6 9 9-5.9.4-8.6 3.1-9 9-.4-5.9-3.1-8.6-9-9 5.9-.4 8.6-3.1 9-9Z" />
    <template v-else-if="name === 'wallet'"><path d="M4 6h15v13H4z" /><path d="M4 9h15M15 13h4v3h-4z" /></template>
    <template v-else-if="name === 'search'"><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></template>
    <path v-else-if="name === 'x'" d="m6 6 12 12M18 6 6 18" />
    <template v-else-if="name === 'camera'"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3Z" /><circle cx="12" cy="13" r="3.5" /></template>
    <template v-else-if="name === 'calendar'"><rect x="4" y="5" width="16" height="15" rx="2" /><path d="M8 3v4M16 3v4M4 10h16M9 14h2M13 14h2M9 17h2" /></template>
    <template v-else-if="name === 'pen'"><path d="M4 20c3-1 5-4 7-4s2 3 4 3 3-2 5-2" /><path d="m14 4 4 4-7 7H7v-4z" /></template>
    <template v-else-if="name === 'bell'"><path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4z" /><path d="M10 20a2 2 0 0 0 4 0" /></template>
    <template v-else-if="name === 'card'"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M7 15h4" /></template>
    <template v-else-if="name === 'user'"><circle cx="12" cy="8" r="4" /><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" /></template>
    <template v-else-if="name === 'chart'"><path d="M4 20V4M4 20h16" /><path d="M8 16v-4M12 16V8M16 16v-6" /></template>
    <template v-else-if="name === 'quote'"><path d="M14 3H6v18h12V7z" /><path d="M14 3v4h4" /><path d="M8.5 16c1.4-1.8 2.3-1.8 3.2 0s1.9 1.8 3.3-.4" /></template>
  </svg>
</template>
